import React, { Component } from 'react';
import { Input, Form, Row, Col, Modal, DatePicker, message, Select, Button, Upload, Icon } from 'antd';
import { Message } from 'semantic-ui-react';
import moment from 'moment';

import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import BaseUrlConfig from '../../../../../net/BaseUrlConfig';
import UrlConfig from '../../../../../net/UrlConfig';

const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 14 },
};

const countryOptions = ['SG', 'HK', 'IN', 'JP'];
const regulatorOptions = ['MAS', 'SFC', 'SEBI', 'KFB'];

const licenseOptions = [
  'CMSL-Fund Management',
  'Type 9-Asset Management',
  'Investment Adviser',
  'To be obtained',
];

const examStatusOptions = ['Not applicable', 'Not passed', 'Passed', 'Exempted'];

class AddOrEditLicenseModalDialog extends Component {
  componentDidUpdate() {
    const { addOrEditLicenseActionStatus, addOrEditLicenseModal } = this.props;

    if (addOrEditLicenseActionStatus === ACTION_STATUS.SUCCESS) {
      const actionText = addOrEditLicenseModal.mode === 'ADD'
        ? 'Add'
        : addOrEditLicenseModal.mode === 'COPY'
          ? 'Copy'
          : 'Edit';
      message.success(`${actionText} License succeeded`);
      this.props.initAddOrEditLicenseActionStatus();
      this.props.resetAddOrEditLicenseModal();
      this.refreshQuery();
    }

    if (addOrEditLicenseActionStatus === ACTION_STATUS.ERROR) {
      this.props.initAddOrEditLicenseActionStatus();
    }
  }

  refreshQuery = () => {
    const { employee, regulator, showAll } = this.props.licenseQueryFields;
    this.props.loadLicenseInfo({ employee, regulator, showAll });
  };

  onInputChange = ({ name, value }) => {
    this.props.addOrEditLicenseChangeInput({ name, value });
  };

  attachmentHandleChange = info => {
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    this.onInputChange({ name: 'fileList', value: fileList });

    if (fileList.length > 0 && fileList[0].response && fileList[0].response.data) {
      this.onInputChange({ name: 'attachment', value: fileList[0].response.data.fileNameWithTimeStamp });
      this.onInputChange({ name: 'attachmentOriginName', value: fileList[0].response.data.originalFileName });
    }
    if (fileList.length === 0) {
      this.onInputChange({ name: 'attachment', value: '' });
      this.onInputChange({ name: 'attachmentOriginName', value: '' });
    }
  };

  submitAddOrEditLicense = () => {
    const { fields, mode } = this.props.addOrEditLicenseModal;
    this.props.form.validateFields(err => {
      if (!err) {
        this.props.addOrEditLicense({
          id: fields.id,
          employee: fields.employee,
          country: fields.country,
          registration: fields.registration,
          license: fields.license,
          role: fields.role,
          licenseNo: fields.licenseNo,
          licenseDate: fields.licenseDate,
          cessationDate: fields.cessationDate,
          examStatus: fields.examStatus,
          attachment: fields.attachment,
          attachmentOriginName: fields.attachmentOriginName,
          mode,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { addOrEditLicenseModal, employeeOptions, addOrEditLicenseActionStatus } = this.props;
    const { isOpened, mode, respErrMsg, fields } = addOrEditLicenseModal;
    const isSubmitLoading = addOrEditLicenseActionStatus === ACTION_STATUS.LOGINING;

    const employeeOptionNodes = employeeOptions.map(item => (
      <Option key={item} value={item}>{item}</Option>
    ));

    const attachmentUrl = fields.attachment
      ? `${BaseUrlConfig.api.REST_URL}${BaseUrlConfig.api.API_VERSION}${UrlConfig.DOWNLOAD_LICENSE_ATTACHMENT}/${fields.attachment}`
      : '';
    const uploadAttachmentUrl = `${BaseUrlConfig.api.REST_URL}${BaseUrlConfig.api.API_VERSION}${UrlConfig.UPLOAD_LICENSE_ATTACHMENT}`;

    const modalTitle = mode === 'ADD' ? 'Add License' : mode === 'COPY' ? 'Copy License' : 'Edit License';

    return (
      <Modal
        title={modalTitle}
        centered
        width={1000}
        visible={isOpened}
        destroyOnClose={true}
        maskClosable={false}
        onCancel={this.props.resetAddOrEditLicenseModal}
        footer={[
          <Button key="close" onClick={this.props.resetAddOrEditLicenseModal}>
            Close
          </Button>,
          <Button key="submit" type="primary" loading={isSubmitLoading} onClick={this.submitAddOrEditLicense}>
            Submit
          </Button>,
        ]}
      >
        <Form layout="horizontal">
          <Row gutter={24}>
            <Col span={12}>
              <FormItem {...formItemLayout} label="Employee">
                {getFieldDecorator('employee', {
                  initialValue: fields.employee || undefined,
                  rules: [{ required: true, message: 'Please select Employee' }],
                })(
                  <Select
                    allowClear
                    showSearch
                    filterOption={false}
                    placeholder="Employee"
                    onSearch={this.props.loadLicenseEmployeeOptions}
                    onFocus={() => this.props.loadLicenseEmployeeOptions('')}
                    onChange={value => this.onInputChange({ name: 'employee', value })}
                  >
                    {employeeOptionNodes}
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem {...formItemLayout} label="Country">
                {getFieldDecorator('country', {
                  initialValue: fields.country || undefined,
                })(
                  <Select
                    allowClear
                    placeholder="Country"
                    onChange={value => this.onInputChange({ name: 'country', value })}
                  >
                    {countryOptions.map(item => (
                      <Option key={item} value={item}>{item}</Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={12}>
              <FormItem {...formItemLayout} label="Regulator">
                {getFieldDecorator('registration', {
                  initialValue: fields.registration || undefined,
                })(
                  <Select
                    allowClear
                    placeholder="Regulator"
                    onChange={value => this.onInputChange({ name: 'registration', value })}
                  >
                    {regulatorOptions.map(item => (
                      <Option key={item} value={item}>{item}</Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem {...formItemLayout} label="License">
                {getFieldDecorator('license', {
                  initialValue: fields.license || undefined,
                })(
                  <Select
                    allowClear
                    placeholder="License"
                    onChange={value => this.onInputChange({ name: 'license', value })}
                  >
                    {licenseOptions.map(item => (
                      <Option key={item} value={item}>{item}</Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={12}>
              <FormItem {...formItemLayout} label="Role">
                {getFieldDecorator('role', {
                  initialValue: fields.role,
                })(
                  <Input onChange={e => this.onInputChange({ name: 'role', value: e.target.value })} />
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem {...formItemLayout} label="License No">
                {getFieldDecorator('licenseNo', {
                  initialValue: fields.licenseNo,
                })(
                  <Input onChange={e => this.onInputChange({ name: 'licenseNo', value: e.target.value })} />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={12}>
              <FormItem {...formItemLayout} label="License Date">
                {getFieldDecorator('licenseDate', {
                  initialValue: fields.licenseDate ? moment(fields.licenseDate) : null,
                })(
                  <DatePicker
                    style={{ width: '100%' }}
                    onChange={(date, dateString) => this.onInputChange({ name: 'licenseDate', value: dateString })}
                  />
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem {...formItemLayout} label="Cessation Date">
                {getFieldDecorator('cessationDate', {
                  initialValue: fields.cessationDate ? moment(fields.cessationDate) : null,
                })(
                  <DatePicker
                    style={{ width: '100%' }}
                    onChange={(date, dateString) => this.onInputChange({ name: 'cessationDate', value: dateString })}
                  />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={12}>
              <FormItem {...formItemLayout} label="Exam Status">
                {getFieldDecorator('examStatus', {
                  initialValue: fields.examStatus || undefined,
                })(
                  <Select
                    allowClear
                    placeholder="Exam Status"
                    onChange={value => this.onInputChange({ name: 'examStatus', value })}
                  >
                    {examStatusOptions.map(item => (
                      <Option key={item} value={item}>{item}</Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem {...formItemLayout} label="Attachment">
                <Upload
                  name="file"
                  withCredentials={true}
                  multiple={false}
                  fileList={fields.fileList}
                  action={uploadAttachmentUrl}
                  onChange={this.attachmentHandleChange}
                >
                  <Button style={{ width: '100%' }}>
                    <Icon type="upload" /> Upload
                  </Button>
                </Upload>
                {attachmentUrl ? (
                  <div style={{ marginTop: 8 }}>
                    <a href={attachmentUrl} target="_blank" rel="noopener noreferrer">
                      {fields.attachmentOriginName || fields.attachment}
                    </a>
                  </div>
                ) : null}
              </FormItem>
            </Col>
          </Row>
        </Form>
        {!!respErrMsg && (
          <Message negative>
            <Message.Header>Response Error Message</Message.Header>
            <p>{respErrMsg}</p>
          </Message>
        )}
      </Modal>
    );
  }
}

const AddOrEditLicenseModalDialogForm = Form.create({ name: 'AddOrEditLicenseModalDialog' })(AddOrEditLicenseModalDialog);

export default AddOrEditLicenseModalDialogForm;
